module.exports = __webpack_public_path__ + "img/IMG-20200715-WA0017.891dfd7e.jpg";